import { Menu, MenuItem, MenuProps } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ShareButtonLink } from '../shareButtonLink';
import { ShareLinkItem } from '../types';

const useStyles = makeStyles({ name: 'ShareButtonDesktopMenu' })((theme) => ({
	menuPaper: {
		marginTop: 8
	},
	menuList: {
		padding: 0
	},
	menuItem: {
		padding: 0
	},
	link: {
		width: '100%'
	}
}));

export type ShareButtonDesktopMenuProps = Omit<MenuProps, 'children'> & {
	onClose: () => void;
	items: ShareLinkItem[];
};

export const ShareButtonDesktopMenu: React.FC<ShareButtonDesktopMenuProps> = (props) => {
	const { onClose, items, ...other } = props;

	const { classes } = useStyles();

	const closeMenu = () => {
		onClose?.();
	};

	const createMenuItem = (shareLinkItem: ShareLinkItem) => {
		return shareLinkItem.createShareLink(<ShareButtonLink Icon={shareLinkItem.Icon} label={shareLinkItem.label} />, classes.link);
	};

	return (
		<Menu
			{...other}
			onClose={closeMenu}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
			transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			classes={{ paper: classes.menuPaper, list: classes.menuList }}>
			{items.map(shareLinkItem =>
				<MenuItem className={classes.menuItem} onClick={closeMenu}>
					{createMenuItem(shareLinkItem)}
				</MenuItem>)}
		</Menu>
	);
};
